import React, { useState, useContext } from "react";
import axios from "axios";
import MyContext from "../../MyContext";
import { toast } from "react-toastify";
import contact from "../../images/LandingPageImage/contact.png";

const ContactSection = ({ contactImg }) => {
    const { baseUrl } = useContext(MyContext);

  const [formData, setFormData] = useState({
    fullName: "",
    phoneNumber: "",
    workEmail: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.fullName || !formData.phoneNumber || !formData.workEmail) {
      toast.error("Please fill all required fields");
      return;
    }

    setLoading(true);

    try {
      const payload = {
        userid: "",
        step: "1",
        step1: {
        fullName: formData.fullName,
        phoneNumber: formData.phoneNumber,
        workEmail: formData.workEmail,
        message: formData.message,
        },
      };

      const response = await axios.post(
         `${baseUrl}/api/User/v1.0/updateUserDetails`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
             Authorization:
              "Basic YW5sb29rQGdtYWlsLmNvbTpBbmxvb2tAMTIzNDU=",
          },
        }
      );

      if (response.status === 200) {
        toast.success("Form submitted successfully");

        setFormData({
          fullName: "",
          phoneNumber: "",
          workEmail: "",
          message: "",
        });
      } else {
        toast.error(response?.data?.message || "Submission failed");
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Something went wrong"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="py-5" style={{ backgroundColor: "#ffffff" }}>
      <div className="container">
        <div className="row align-items-center g-5">
        
          <div className="col-lg-6">
            <div className="mb-4">
              <img
                src={contact}
                alt="Contact"
                className="img-fluid rounded"
                style={{ maxWidth: "360px" }}
              />
            </div>

            <h2 className="fw-bold" style={{ color: "#0C4D45" }}>
              We’re Here to <br /> Support Your Business Growth
            </h2>

            <p className="text-secondary mt-3" style={{ maxWidth: "420px" }}>
              Have questions or need assistance? Our dedicated team is always
              ready to help.
            </p>
          </div>

          {/* RIGHT FORM */}
          <div className="col-lg-6">
            <div
              className="p-4 p-md-5"
              style={{
                border: "1px solid #1ec997",
                borderRadius: "12px",
                backgroundColor: "#ffffff",
              }}
            >
              <h4 className="text-center mb-4" style={{ color: "#0C4D45" }}>
                Get in Touch
              </h4>

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <input
                    type="text"
                    name="fullName"
                    className="form-control form-control-lg"
                    placeholder="Full Name"
                    value={formData.fullName}
                    onChange={handleChange}
                  />
                </div>

                <div className="mb-3">
                  <input
                    type="tel"
                    name="phoneNumber"
                    className="form-control form-control-lg"
                    placeholder="Phone Number"
                    value={formData.phoneNumber}
                    onChange={handleChange}
                  />
                </div>

                <div className="mb-3">
                  <input
                    type="email"
                    name="workEmail"
                    className="form-control form-control-lg"
                    placeholder="Work Email"
                    value={formData.workEmail}
                    onChange={handleChange}
                  />
                </div>

                <div className="mb-4">
                  <textarea
                    name="message"
                    className="form-control form-control-lg"
                    rows="4"
                    placeholder="Message"
                    value={formData.message}
                    onChange={handleChange}
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="btn w-100 py-3 fw-semibold"
                  disabled={loading}
                  style={{
                    backgroundColor: "#00c97f",
                    color: "#fff",
                    borderRadius: "8px",
                  }}
                >
                  {loading ? "Submitting..." : "Submit"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
